import React from "react";
import { segsFromMarked } from "../lib/markedSegs";

/**
 * `tt()` 로 받은 「**굵게**」 표시 문장을 그대로 그린다 — 굵은 자리는 `<b>`.
 * 「앞 조각 + <b>굵게</b> + 뒤 조각」 세 키를 JSX 로 이어 붙이던 자리를 한 키로 바꿀 때 쓴다(2026-09-07 전수 검수).
 *   <MarkedText text={tt("a.xxxxxxxx", "권리사가 지정한 **브랜드 채널**에서만 사용할 수 있어요.")} />
 */
export default function MarkedText({ text, bold: Bold = "b" }) {
  return (
    <>
      {segsFromMarked(text).map((s, i) => (s.strong ? <Bold key={i}>{s.text}</Bold> : <React.Fragment key={i}>{s.text}</React.Fragment>))}
    </>
  );
}
